import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f15dc27"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider" }, null, -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "ion-text-center ion-margin-top"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_slides = _resolveComponent("slides")!
  const _component_section_header = _resolveComponent("section-header")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_home_section = _resolveComponent("home-section")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_page_header, { showSearchIcon: true }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          ($setup.loadingAppPublicData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_spinner)
              ]))
            : (_openBlock(), _createBlock(_component_ion_grid, {
                key: 1,
                fixed: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_slides, { banners: $setup.banners }, null, 8, ["banners"]),
                  _hoisted_2,
                  _createVNode(_component_section_header, {
                    icon: $setup.grid,
                    title: $setup.t('HomePage.productCategories')
                  }, null, 8, ["icon", "title"]),
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_segment, { scrollable: "" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.allProductCategories, (category) => {
                            return (_openBlock(), _createBlock(_component_ion_segment_button, {
                              class: "product-category-btn",
                              key: category.id,
                              value: category.id,
                              "router-link": `/product-list/0/${category.id}`
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_avatar, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: category.imageLink
                                    }, null, 8, _hoisted_3)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($setup.getLocalizedStr(category, 'title', 'titleEn')), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["value", "router-link"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_4,
                  _createElementVNode("div", null, [
                    _createVNode(_component_home_section, {
                      icon: $setup.flame,
                      sectionId: "0b6eb993"
                    }, null, 8, ["icon"]),
                    _createVNode(_component_home_section, {
                      title: $setup.t('HomePage.latestProducts'),
                      icon: $setup.star,
                      products: $setup.latestProducts,
                      link: "ProductListPage"
                    }, null, 8, ["title", "icon", "products"]),
                    _createVNode(_component_home_section, {
                      icon: $setup.time,
                      sectionId: "69d81211"
                    }, null, 8, ["icon"]),
                    ($setup.loadingUser)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_ion_spinner)
                        ]))
                      : (_openBlock(), _createBlock(_component_home_section, {
                          key: 1,
                          title: $setup.t('HomePage.recentBrowse'),
                          icon: $setup.eye,
                          hideSeeMore: true,
                          products: $setup.recentBrowsedProducts
                        }, null, 8, ["title", "icon", "products"]))
                  ]),
                  _createVNode(_component_home_section, {
                    title: $setup.t('HomePage.featuredMerchants'),
                    icon: $setup.bag,
                    link: "MerchantListPage",
                    merchants: $setup.featuredMerchants
                  }, null, 8, ["title", "icon", "merchants"]),
                  _createVNode(_component_home_section, {
                    icon: $setup.sparkles,
                    sectionId: "625796bf",
                    useRowCol: true
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}